import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";
import UserTaxiOfficerList from "./user-taxi-officer-list";
import UserTaxiOfficerListError from "./user-taxi-officer-list-error";
import UserTaxiOfficerListParams from "./user-taxi-officer-list-params";

const useTaxiOfficerList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserTaxiOfficerList>({ data: [], totalCount: 0 });

  const load = async (
    params: UserTaxiOfficerListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiOfficerList = await userService.getTaxiOfficerList(
        params,
        signal,
      );

      setData(taxiOfficerList);
      setIsLoading(false);
    } catch (_error) {
      const error = _error as UserTaxiOfficerListError;

      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useTaxiOfficerList;
